export default "__VITE_ASSET__BTbKw3sk__"